/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

// https://github.com/ReactiveX/rxjs/issues/5163
// https://github.com/cartant/rxjs-etc/blob/5447f8901e390894acdb29623e88a3cc184b1f4d/source/util.ts#L15-L17
// TODO Remove after update to RxJS v7
export function isTruthy<T>(value: T): value is NonNullable<T> {
  return !!value;
}
